import { createApi } from "@reduxjs/toolkit/query/react";
import { baseAuthQuery } from "../base/baseApi";
import { ApiResponse } from "../base/apiResponse";
import { FacultyRequest, FacultyResponse } from "../../models/dtos";

export const facultiesApi = createApi({
  reducerPath: "facultiesApi",
  baseQuery: baseAuthQuery("Faculties"),
  tagTypes: ["Faculty"],
  endpoints: (builder) => ({
    getFaculties: builder.query<ApiResponse<FacultyResponse[]>, void>({
      query: () => "",
      providesTags: ["Faculty"],
    }),
    getFacultyById: builder.query<ApiResponse<FacultyResponse>, number>({
      query: (id) => ({ url: `/${id}` }),
      providesTags: ["Faculty"],
    }),
    updateFaculty: builder.mutation<ApiResponse<FacultyResponse>, Partial<FacultyRequest>>({
      query: (body) => ({ url: "CreateOrUpdate", method: "POST", body }),
      invalidatesTags: ["Faculty"],
    }),
    deleteFaculty: builder.mutation<ApiResponse<boolean>, number>({
      query: (id) => ({ url: `Delete/${id}`, method: "GET" }),
      invalidatesTags: ["Faculty"],
    }),
  }),
});
